export default "__VITE_ASSET__Z6Zc67xZ__"